<template>
  <div class="scroll-rect">
    <div
      ref="scrollContent"
      class="scroll-content"
      :class="{
        'flow-text': flowText,
        'flex-height': flex,
        flex: flex,
        'flex-col': flex,
        'overflow-x-hidden': scroll,
        'overflow-y-auto': scroll,
        'overflow-hidden': !scroll && !overflowVisible,
        'overflow-visible': !scroll && overflowVisible
      }"
      @scroll="onScroll"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "ContentScrollContainer",
  props: {
    flowText: { type: Boolean, default: false },
    flex: { type: Boolean, default: false },
    scroll: { type: Boolean, default: true },
    overflowVisible: { type: Boolean, default: false },
    /**
     * Sets the scroll position when the component is mounted. Used to restore the view state when returning from another view
     * */
    initialScrollPosition: { type: Number, default: null },
    scrollBus: { type: Vue, default: null }
  },
  mounted() {
    if (this.scrollBus != null) {
      this.scrollBus.$on("scroll", this.triggerScroll);
    }
    if (this.initialScrollPosition != null) {
      setTimeout(() => {
        this.$refs["scrollContent"].scrollTop = this.initialScrollPosition;
      }, 20);
    }
  },
  destroyed() {
    if (this.scrollBus != null) {
      this.scrollBus.$off("scroll", this.triggerScroll);
    }
  },
  methods: {
    triggerScroll(scrollTop) {
      this.$refs["scrollContent"].scrollTop = scrollTop;
    },
    onScroll(event) {
      this.$emit("scroll", event);
    }
  }
};
</script>

<style lang="scss" scoped>
.scroll-rect {
  position: relative;
  width: 100%;
  height: 100%;
}
.scroll-rect > .scroll-content {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  min-height: 100%;
}
.scroll-rect > .scroll-content.flex-height {
  height: 100%;
}
</style>
